import { render, staticRenderFns } from "./ComPersonAddAssembly.vue?vue&type=template&id=08a44095&scoped=true&"
import script from "./ComPersonAddAssembly.vue?vue&type=script&lang=js&"
export * from "./ComPersonAddAssembly.vue?vue&type=script&lang=js&"
import style0 from "./ComPersonAddAssembly.vue?vue&type=style&index=0&id=08a44095&prod&scoped=true&lang=scss&"
import style1 from "./ComPersonAddAssembly.vue?vue&type=style&index=1&id=08a44095&prod&lang=scss&"
import style2 from "./ComPersonAddAssembly.vue?vue&type=style&index=2&id=08a44095&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a44095",
  null
  
)

export default component.exports